// Shared calendars and imports load independently. Only prune preferences for
// the group that successfully loaded; the other group may still be loading.
export function pruneHiddenCalendarKeys(
  hidden: Set<string>,
  group: 'spaces' | 'imports',
  availableIds: string[],
): Set<string> {
  const valid = new Set(availableIds.map((id) => group === 'imports' ? `import:${id}` : id));
  const next = new Set([...hidden].filter((key) => {
    if (key === 'personal') return true;
    if (key.startsWith('import:') !== (group === 'imports')) return true;
    return valid.has(key);
  }));
  return next.size === hidden.size ? hidden : next;
}
